import AISettingPage from './AISettingPage'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/aiSettings',
      component: AISettingPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/aiSettingConfig.js